export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9717.9f40a7cb.jpg";